import gql from 'graphql-tag';

export const GET_CUSTOMER_PROPOSALS = gql`
  query GetCustomerProposals($customerAccountId: ID!) {
    customer {
      customerProposals(customerAccountId: $customerAccountId) {
        error
        success
        list {
          proposalId
          amountRequested
          vendorOpportunityId
          firstName
          lastName
          businessName
          status
          createdDateTime
          salesPersonName
          saleType
        }
      }
    }
  }
`;
